module.exports = __webpack_public_path__ + "img/cjsl.96787f59.png";